// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".selWidth[data-v-271d5054] {\n  width: 350px !important;\n}", ""]);
// Exports
module.exports = exports;
